<ng-container *ngIf="dialect">
  <!-- div class="connect-head {{ btnClose ? '' : 'no-close' }}" -->
  <div class="connect-head no-close">

    <div class="head-box">
      <div class="dialect">{{ dialect.word }}</div>
    </div>

    <!-- div class="menu-box" *ngIf="btnClose">
      <a class="close-btn"
         (click)="onClose($event)"></a>
    </div -->
  </div>

  <div class="connect-body">

    <div class="layout-box">
      <article class="label-item type-{{ GetRegion2Css(dialect.area1) }}">{{ GetRegion2Name(dialect.area1) }}</article>
      <!-- issue #208: 사투리 단어 내용에서는 area2(도시명)를 숨긴다.
      <article class="label-item type-{{ GetRegion2Css(dialect.area1) }}sub"
               *ngIf="dialect.area2">{{ dialect.area2 }}</article>
      -->
    </div>

    <div class="meaning-list">
      <ng-container *ngFor="let meaning of dialect.meaning2.slice(0,3); let idx = index">
        <div class="meaning-box" *ngIf="dialect.GetMeaning2Nth(idx)">
          <div class="subject">{{(idx > 0 && !dialect.GetMeaning2Nth(0) || idx === 0) ? "뜻" : ""}}{{ idx > 0 ? idx : "" }}</div>
          <div class="con" [innerHTML]="meaning | resize | keepHtml"></div>
        </div>
      </ng-container>
    </div>

    <div class="more-btn-box"
         *ngIf="showMoreBtn">
      <a class="more-btn" (click)="onGotoDetail($event)">
        자세히 보기 {{ getMoreMeanings(dialect) > 0 ? '(' + getMoreMeanings(dialect) + '개의 뜻이 더 있습니다)' : ''}}
      </a>

    </div>
  </div>
</ng-container>
